import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

document.addEventListener('DOMContentLoaded', () => {
    const lightbox = GLightbox({
        selector: '*[data-lightbox]',
    });
});
